import React from 'react'
import { useHistory } from 'react-router'

// utils
import { createRequestCards } from './RequestsByStatus.collection.utils'

// graphql
import { useQuery } from '@apollo/client'
import { GET_EQUIPMENT_REQUESTS_BY_STATUS } from '../../../../../graphql/equipmentRequest/equipmentRequest.queries'

// components
import FourSectionCardListItem from '../../../../../components/collections/FourSectionCardListItem/FourSectionCardListItem.component'

export default function RequestsByStatus({ status }) {
    const history = useHistory()

    let cards = []

    const { data } = useQuery(GET_EQUIPMENT_REQUESTS_BY_STATUS, {
        variables: { status },
        fetchPolicy: 'network-only'
    })

    if(data && data.equipmentRequestsByStatus) {
        cards = [...createRequestCards(data.equipmentRequestsByStatus)]
    }

    return (<div className='requests-by-status'>

        {
            cards.map(card => {
                return (<FourSectionCardListItem 
                    mainTitle={card.job.name}
                    subTitle={card.status}
                    leftData={[`${card.numItems} Item${card.numItems !== 1 ? 's' : ''}`]}
                    rightData={card.dateRequested}
                    onClick={() => history.push(`/requests/details/${card.id}`)}
                />)
            })
        }
    </div>)
}